export default __webpack_public_path__ + "static/media/th.913a9cb0.svg";